import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CollectorEligibilityContext,
  CollectorUser,
  EligibleCollectorUser
} from '../domain/user';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseUrl = environment.API_HOST + '/api/users';

  constructor(private http: HttpClient) {}

  searchUsersByName(query: string): Observable<CollectorUser[]> {
    const params = new HttpParams().set('query', query);
    return this.http.get<CollectorUser[]>(`${this.baseUrl}/search`, {
      params
    });
  }

  searchCollectorsByName(query: string): Observable<CollectorUser[]> {
    const params = new HttpParams().set('query', query);
    return this.http.get<CollectorUser[]>(`${this.baseUrl}/search-collectors`, {
      params
    });
  }

  searchEligibleCollectorsByName(
    query: string,
    context: CollectorEligibilityContext
  ): Observable<EligibleCollectorUser[]> {
    if (context.draftRoster && Number.isInteger(context.currentEventIndex)) {
      return this.http.post<EligibleCollectorUser[]>(
        `${this.baseUrl}/search-collectors`,
        {
          query,
          currentEventIndex: context.currentEventIndex,
          draftRoster: context.draftRoster
        }
      );
    }

    let params = new HttpParams()
      .set('query', query)
      .set('gameId', context.gameId)
      .set('eventCode', context.eventCode);
    if (context.eventId !== undefined) {
      params = params.set('eventId', context.eventId ?? '');
    }
    if (context.dcDate !== undefined) {
      params = params.set('dcDate', context.dcDate ?? '');
    }
    if (context.dcTime !== undefined) {
      params = params.set('dcTime', context.dcTime ?? '');
    }
    if (context.dcType !== undefined) {
      params = params.set('dcType', context.dcType ?? '');
    }
    if (context.dcSubtype !== undefined) {
      params = params.set('dcSubtype', context.dcSubtype ?? '');
    }
    if (context.dcTypeOverride !== undefined) {
      params = params.set('dcTypeOverride', context.dcTypeOverride ?? '');
    }
    if (context.gmTeamLeaderAuthId !== undefined) {
      params = params.set(
        'gmTeamLeaderAuthId',
        context.gmTeamLeaderAuthId ?? ''
      );
    }
    return this.http.get<EligibleCollectorUser[]>(
      `${this.baseUrl}/search-collectors`,
      { params }
    );
  }

  findByAuth0Ids(ids: string[]): Observable<CollectorUser[]> {
    const params = new HttpParams().set('ids', ids.join(','));
    return this.http.get<CollectorUser[]>(`${this.baseUrl}/by-auth0-ids`, {
      params
    });
  }
}
